<template>
  <div class="quick-info-footer">
    <v-tooltip bottom v-if="$security.checkUserAccess('ViewMeeting')">
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          v-bind="attrs"
          v-on="on"
          v-if="$security.checkUserAccess('ViewMeeting')"
          small
          @click="openMeetingDayPage(data.id)"
          color="primaryDark"
          class="mr-0"
        >
          {{ $t("btnView") }}</a-btn
        >
      </template>
      <span>{{ $t("btnView") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="$security.checkUserAccess('UpdateMeeting')">
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          v-bind="attrs"
          v-on="on"
          v-if="$security.checkUserAccess('UpdateMeeting')"
          small
          @click="onEditMeeting(data.id)"
          color="primaryDark"
          class="ml-3"
        >
          {{ $t("btnEdit") }}</a-btn
        >
      </template>
      <span>{{ $t("btnEdit") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="$security.checkUserAccess('DeleteMeeting')">
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          v-bind="attrs"
          v-on="on"
          v-if="$security.checkUserAccess('DeleteMeeting')"
          small
          @click="onDeleteMeeting(data.id)"
          color="primaryDark"
          class="ml-3 mr-2"
        >
          {{ $t("btnDelete") }}</a-btn
        >
      </template>
      <span>{{ $t("btnDelete") }}</span>
    </v-tooltip>
    <confirm-dialog ref="confirm" />
    <meeting
      v-if="dialogMeeting"
      v-model="dialogMeeting"
      :selectedMeeting="data"
    ></meeting>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ConfirmDialog from "../../../ConfirmDialog.vue";
import Meeting from "../../meeting.vue";
export default {
  components: { ConfirmDialog, Meeting },
  name: "QuickInfoFooter",
  data() {
    return {
      data: {},
      dialogMeeting: false,
    };
  },
  computed: {
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  methods: {
    ...mapActions({
      deleteMeetingData: "meeting/deleteMeeting",
    }),
    onDeleteMeeting,
    deleteMeeting,
    onEditMeeting,
    closeMeetingDialog,
    openMeetingDayPage,
  },
};

function onEditMeeting(id) {
  this.dialogMeeting = true;
}
async function onDeleteMeeting(id) {
  if (
    await this.$refs.confirm.open(
      this.$t("lblConfirm"),
      this.$t("msgConfirmDeletion")
    )
  ) {
    this.deleteMeeting(id);
  }
}

function deleteMeeting(id) {
  this.deleteMeetingData(id).then(() => {
    this.$root.$emit("onDeleteMeeting", this.data);
  });
}

function closeMeetingDialog() {
  this.dialogMeeting = false;
}

function openMeetingDayPage(id) {
  this.$router.push("/meeting/" + id + "/calendar/tenant/" + this.tenantId);
}
</script>
